import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useDialogParams, MemoWrap } from '../../utils';
import { Dialog } from '../Dialog';
import { DialogContextProvider } from '../../context';

/**
 * Компонент-обёртка для прокидывания контекста и инициализации компонента самой модалки.
 * Добавлена мемоизация оборачиваемых компонентов для исключения полного ререндеринга
 * при изменении значения в контексте
 * */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WithDialog = function WithDialog(_ref) {
  var children = _ref.children;
  var _useDialogParams = useDialogParams(),
    confirm = _useDialogParams.confirm,
    dialogParams = _useDialogParams.dialogParams;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MemoWrap, {
      children: /*#__PURE__*/_jsx(DialogContextProvider, {
        value: confirm,
        children: children
      })
    }), /*#__PURE__*/_jsx(Dialog, _objectSpread({}, dialogParams))]
  });
};
WithDialog.displayName = 'WithDialog';